/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap'

import PasswordWidget from '../widgets/PasswordWidget.js'
import { AppContext } from '../AppContext'

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

class Login extends React.Component
{
  identificationElement = null;

  async componentDidMount()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getLoginPageSettings');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving login page settings');
    this.setState({profileName: result.jsonData.profileName + ': Login', smtpEnabled: result.jsonData.smtpEnabled});
  }

  constructor(props)
  {
    super();

    this.state =
    {
      sessionStatus: 'inactive',
      buttonDisabled: true,
      passwordDisabled: true,
      identificationDisabled: false,
      identification: '',
      password: '',
      spinnerIsSpinning: false
    }

    this.setIdentification = this.setIdentification.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.login = this.login.bind(this);
  }

  async login(event)
  {
    if (undefined !== event) event.preventDefault();

    this.setState(
    {
      spinnerIsSpinning: true,
      buttonDisabled: true,
      passwordDisabled: true,
      identificationDisabled: true
    });

    let bodyData = {};
    bodyData.identification = this.state.identification;
    bodyData.password = this.state.password;

    let result = await this.context.dbTwig.callRestAPI('icam', 'createUserSession', bodyData);
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status)
    {
      this.setState(
      {
        buttonDisabled: true,
        passwordDisabled: true,
        identificationDisabled: false,
        identification: '',
        password: '',
        smtpEnabled: 'N',
        profileName: ''
      });
      this.identificationElement.focus();
      return this.context.dbTwig.apiErrorHandler(result, 'Login failed');
    } 

    switch (result.jsonData.sessionStatus)
    {
      case 'active':
      case 'change password':
      case 'session limit':
      case 'auth code':
        this.context.authorize(result.jsonData);
        break;

      case 'login url':
        this.context.postNotification('info', 'A unique login URL has been sent to your email');
        this.setState({identification: '', password: ''});
        break;

      default:
        break;
    }
  }

  render()
  {
    let recoverLink = ('Y' === this.state.smtpEnabled ? (<Link to="/recoverAccount">Recover identification or password</Link>) : null);
    let newUserLink = null;

    document.title = this.state.profileName;

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    return(  
      <div>
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader css={override} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning} />          
        </div>
        <br />
        <Form name="login" onSubmit={(e) => this.login(e)}>
          <FormGroup row id="identificationFormGroup">
            <Label for="identification" sm='1'>Identity</Label>
            <Col sm="3">
              <Input type="text" id="identification" value={this.state.identification} placeholder="Enter your identification" autoFocus={true} 
                onChange={this.setIdentification} disabled={this.state.identificationDisabled} 
                innerRef={(ref) => this.identificationElement = ref}
              />
            </Col>
          </FormGroup>
          <FormGroup row id="passwordFormGroup">
            <Label for="password" sm='1'>Password</Label>
            <Col sm="3" >
              <PasswordWidget disabled={this.state.passwordDisabled} onChange={this.setPassword} buttonDisabled={this.state.buttonDisabled}
                login={this.login} placeholder='Enter your password' value={this.state.password} id="password"/>
            </Col>
          </FormGroup>
          <Row>
            <Col sm={{ size: 1, offset: 1 }}>
              <Button type="submit" color="primary" id="loginButton" disabled={this.state.buttonDisabled}>Login</Button>
            </Col>
          </Row>
          <hr></hr>
          <Row>
            <Col sm={{ size: 4, offset: 1}}>
              {recoverLink}
            </Col>
            <Col sm="1" className="text-right">
              {newUserLink}
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  setPassword(password)
  {
    let disabled = ('' === password ? true : false);
    this.setState({password: password, buttonDisabled: disabled});
  }

  setIdentification(event)
  {
    let password = ('' === event.target.value ? '' : this.state.password);
    this.setState(
    {
      identification: event.target.value,
      passwordDisabled: '' === event.target.value ? true : false,
      password: password
    });
  }
}

Login.contextType = AppContext;

export default Login